import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  textDate: {
    letterSpacing: -0.8,
    marginTop: 5,
  },
});
